import React from 'react'

interface IAvatarProps extends React.HTMLProps<HTMLDivElement> {
  src?: string
  children?: React.ReactNode | string
  shape?: 'round' | 'square'
  skeleton?: boolean
}

const Avatar: React.FC<IAvatarProps> = ({
  src,
  children,
  shape = 'round',
  skeleton,
  ...rest
}) => (
  <div
    className={`avatar avatar-${shape} ${skeleton ? 'skeleton' : ''}`}
    style={src && !skeleton ? { backgroundImage: `url(${src})` } : undefined}
    {...rest}
  >
    {children}
  </div>
)

export default Avatar
